const state = {
  title: '',
  items: [],
  total: 0
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items,
  getTotal: state => state.total,
  getOffset: state => state.items.length
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  },
  UPDATE_TOTAL: (state, number) => {
    state.total = number || 0
  },
  ADD_ITEMS: (state, array) => {
    state.items = [...state.items, ...array]
  }
}

const actions = {
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  },
  updateTotal: ({ commit, dispatch }, total) => {
    commit('UPDATE_TOTAL', total)
  },
  addItems: ({ commit, dispatch }, documents) => {
    commit('ADD_ITEMS', documents.items)
    dispatch('updateTotal', documents.total)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
